import { animate, createScope } from 'animejs';
import { useEffect, useRef } from 'react';
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";
import TitansNavbar from "../Components/TitansNavbar";
// import TitansHero from "../Components/TitansHero";
import TitansHero2 from "../Components/TitansHero2";

function TitansAcademy() {
  const readyText = useRef(null);
  const scope = useRef(null);

  useEffect(() => {
    
      scope.current = createScope({ readyText }).add( self => {
      
        // Every anime.js instance declared here is now scoped to <div ref={root}>
  
        // Created a sliding animation loop
        animate('.titansRedTitle', 
          { translateX: [-600, 0],
            opacity: [0, 1],
            easing: 'easeOutExpo',
          });
        
        animate('.lead', 
        { translateX: [600, 0],
          opacity: [0, 1],
          easing: 'easeOutExpo',
        });
      });
  
      // Properly cleanup all anime.js instances declared inside the scope
      return () => scope.current.revert()
  
    }, []);
  return (
    <>
      <Navbar2 />
      <TitansHero2 />
      <TitansNavbar />
        {/* Academy Mission */}
        <div className="container-fluid">
            <div className='titansTitle text-center pt-5 pb-3'>
              ACADEMY MISSION
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>College Ready!</p>
                <p>Game Ready!</p>
                <p>Life Ready!</p>
              </div>
              <div className="col-12 col-lg-6 lead pe-lg-5 pb-5">
                <p>
                  At ADS Prep Academy, we are a development-driven
                  program built to prepare student-athletes to excel
                  in college, compete at the highest levels, and succeed in life.
                </p>
                <p>Our elite trainers, state-of-the-art facilities,
                  and high-performance environment cultivate Absolute
                  Determination and Sacrifice — the foundation of becoming College Ready, Game Ready, and Life Ready.
                  </p>
                  <p>At ADS Prep, preparation becomes a lifestyle.</p>
              </div>
            </div>
        </div>
      <Footer />
    </>
);
}

export default TitansAcademy;
